import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";

import { FiArrowDown, FiArrowRight, FiEye, FiHeart, FiPlay, FiRefreshCw } from "react-icons/fi";
import siteConfig from "../config/siteConfig";

function Main() {
  const [activeSlide, setActiveSlide] = useState(0);
  const heroSlides = [
    "/main/ss26-hero.jpg",
    "/editorial/hero-denim.jpg",
    "/editorial/hero-sage.jpg",
    "/editorial/hero-rose.jpg",
    "/editorial/hero-sand.jpg",
  ];

  useEffect(() => {
    const timer = window.setInterval(
      () => setActiveSlide((slide) => (slide + 1) % heroSlides.length),
      6500
    );
    return () => window.clearInterval(timer);
  }, [heroSlides.length]);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const values = [
    {
      title: "transparant",
      text: "Je vindt pasvorm, stofsamenstelling en onderhoud bij elk model.",
      icon: <FiEye aria-hidden="true" />,
    },
    {
      title: "eerlijk",
      text: "Vergelijk modellen en prijzen op je eigen tempo en stel ons je vragen.",
      icon: <FiHeart aria-hidden="true" />,
    },
    {
      title: "zorgvuldig",
      text: "Met het juiste onderhoud geef je je favoriete broek de aandacht die ze verdient.",
      icon: <FiRefreshCw aria-hidden="true" />,
    },
  ];

  return (
    <main className="home app-page-enter">
      <section className="home-hero" aria-label="Spring Summer 2026 campaign">
        <div className="home-hero__slides" aria-live="polite">
          {heroSlides.map((image, index) => (
            <img
              key={image}
              className={index === activeSlide ? "is-active" : ""}
              src={image}
              alt={index === 0 ? "Two models wearing the Spring Summer collection" : "Spring Summer collection look"}
              loading={index === 0 ? "eager" : "lazy"}
            />
          ))}
        </div>
        <div className="home-hero__overlay" />
        <div className="home-hero__content">
          <p className="eyebrow">Spring / Summer 2026</p>
          <h1>Room to move,<br />space to be<br />yourself.</h1>
          <Link className="text-link" to="/shop" onClick={scrollTop}>
            Ontdek onze SS26 collectie <FiArrowRight aria-hidden="true" />
          </Link>
        </div>
        <div className="home-hero__pagination" aria-label="Campaign slides">
          {heroSlides.map((image, index) => (
            <button
              key={image}
              type="button"
              className={index === activeSlide ? "is-active" : ""}
              onClick={() => setActiveSlide(index)}
              aria-label={`Show campaign image ${index + 1}`}
            />
          ))}
        </div>
        <a className="home-hero__scroll" href="#mission">
          scroll <FiArrowDown aria-hidden="true" />
        </a>
      </section>

      <section className="home-mission" id="mission">
        <p className="eyebrow">Onze missie</p>
        <h2>
          Een eigen ritme. Een fijne pasvorm. Een broek voor de dagen die voor je liggen.
        </h2>
        <p>
          {siteConfig.displayName} brengt denim, chino’s en geklede broeken samen in een overzichtelijke
          collectie. Ontdek de pasvorm, kleur en stof die passen bij jouw dagelijkse ritme.
        </p>
        <Link className="text-link" to="/about" onClick={scrollTop}>
          Lees meer <FiArrowRight aria-hidden="true" />
        </Link>
      </section>

      <section className="home-film">
        <img src="/editorial/home-film.jpg" alt="Tailoring from the Spring Summer collection" loading="lazy" />
        <Link to="/about" onClick={scrollTop} aria-label="Discover our atelier story">
          <FiPlay aria-hidden="true" />
          <span>Bekijk ons verhaal</span>
        </Link>
      </section>

      <section className="home-story">
        <div className="home-story__image">
          <img src="/editorial/home-story.jpg" alt="Warm beige modern fit trousers" loading="lazy" />
          <span>Fit / fabric / people</span>
        </div>
        <div className="home-story__copy">
          <p className="eyebrow">A good pair of trousers</p>
          <h2>Wat is goed?</h2>
          <p>
            Een broek kies je op meer dan kleur alleen. De ruimte bij de taille, de lijn van
            de pijp en het gevoel van de stof bepalen hoe je haar draagt. Daarom vind je bij
            elk model informatie over pasvorm, samenstelling en onderhoud, zodat je rustig
            kunt vergelijken.
          </p>
          <Link className="text-link" to="/about" onClick={scrollTop}>
            Ontdek het atelier <FiArrowRight aria-hidden="true" />
          </Link>
        </div>
      </section>

      <section className="home-inside-out">
        <p className="eyebrow">Everyday details</p>
        <h2>Vind jouw balans tussen vorm, stof en beweging.</h2>
        <div className="home-inside-out__details">
          <div>
            <span>01</span>
            <p>Duidelijke stofinformatie</p>
          </div>
          <div>
            <span>02</span>
            <p>Pasvormen om te vergelijken</p>
          </div>
          <div>
            <span>03</span>
            <p>Aandacht voor onderhoud</p>
          </div>
        </div>
        <Link className="text-link" to="/shop" onClick={scrollTop}>
          Ontdek alle ingrediënten <FiArrowRight aria-hidden="true" />
        </Link>
      </section>

      <section className="home-collections">
        <div className="home-collections__heading">
          <p className="eyebrow">Onze collectie</p>
          <h2 className="display-title">Find your perfect pair.</h2>
        </div>
        <div className="home-collections__grid">
          <article>
            <Link to="/shop?category=Chino" onClick={scrollTop}>
              <div className="home-collections__image">
                <img src="/editorial/home-chino.jpg" alt="Sand slim fit chino" loading="lazy" />
              </div>
              <p className="eyebrow">01 / Chino</p>
              <h3>De veelzijdige allrounder.</h3>
              <p>Een perfecte pasvorm die zowel casual als gekleed gedragen kan worden.</p>
              <span className="text-link">Read more <FiArrowRight aria-hidden="true" /></span>
            </Link>
          </article>
          <article>
            <Link to="/shop?category=Denim" onClick={scrollTop}>
              <div className="home-collections__image">
                <img src="/editorial/home-denim.jpg" alt="Deep indigo slim fit denim" loading="lazy" />
              </div>
              <p className="eyebrow">02 / Denim</p>
              <h3>When in doubt, wear denim.</h3>
              <p>Super stretch, comfortabel en betrouwbaar — ongeacht je maat.</p>
              <span className="text-link">Read more <FiArrowRight aria-hidden="true" /></span>
            </Link>
          </article>
        </div>
      </section>

      <section className="home-origin">
        <div className="home-origin__copy">
          <p className="eyebrow">Discover domtanion</p>
          <h2><span>Everyday choices</span><span>your own style</span></h2>
          <p>
            Een rustige basis laat ruimte voor je eigen stijl. Combineer kleuren en texturen
            en ontdek welke pasvorm bij jou past.
          </p>
          <Link className="text-link" to="/about" onClick={scrollTop}>
            Ons verhaal <FiArrowRight aria-hidden="true" />
          </Link>
        </div>
        <img src="/editorial/home-origin.jpg" alt="Folded sage linen-cotton trousers on a stone bench" loading="lazy" />
      </section>

      <section className="home-values">
        <div className="home-values__heading">
          <p className="eyebrow">Our promise</p>
          <h2>easy mornings,<br />open possibilities,</h2>
        </div>
        <div className="home-values__grid">
          {values.map((value, index) => (
            <article key={value.title}>
              <div className="home-values__icon">{value.icon}</div>
              <span>0{index + 1}</span>
              <h3>{value.title}</h3>
              <p>{value.text}</p>
            </article>
          ))}
        </div>
        <Link className="text-link" to="/about" onClick={scrollTop}>
          Meer over onze visie <FiArrowRight aria-hidden="true" />
        </Link>
      </section>

      <section className="home-read">
        <div>
          <p className="eyebrow">Read / SS26</p>
          <h2>Different days,<br />your own story.</h2>
          <p>
            Van een rustige ochtend tot een volle agenda: ontdek hoe verschillende kleuren,
            stoffen en pasvormen een plek vinden in je garderobe.
          </p>
          <Link className="text-link" to="/about" onClick={scrollTop}>
            Lees ons verhaal <FiArrowRight aria-hidden="true" />
          </Link>
        </div>
        <img src="/editorial/home-read.jpg" alt="Tobacco pleated chino" loading="lazy" />
      </section>
    </main>
  );
}

export default Main;
